export const baseUrl = 'https://api.moviespot.space'  